<top-bar-tabs></top-bar-tabs>
@if (doneLoading) {
  <div>
    <br />
    <embedded-report>
    <mat-card appearance="outlined" class="committee-header">
      <mat-card-title>
        {{ project?.name ? project?.name : "" }}
        <br />
        <small class="status"
          ><b>current status: </b>{{ info.projectStatus }}</small
          >
        </mat-card-title>
      </mat-card>
      <mat-card appearance="outlined" class="container-card">
        <mat-card-content>
          <app-committee-deal-information
          [deal]="info"></app-committee-deal-information>
          <app-committee-deal-dates [deal]="info"></app-committee-deal-dates>
          <hr />
          <committee-reports [projectId]="project.id" [project]="project">
          </committee-reports>
          <app-committee-links
            [readOnly]="readOnly"
            [deal]="info"
            dashboardType="closing"
          [milestones]="[closingMilestone]"></app-committee-links>
          <app-committee-conditions
            [readOnly]="readOnly"
            [projectId]="project.id"
            [milestone]="closingMilestone"
            [milestoneId]="closingMilestone.id"
            title="FOLLOW-UP ITEMS"
            [approvalType]="itemsService.getLegalApprovalType()"
          [milestones]="[closingMilestone]"></app-committee-conditions>
          <app-milestone-sections
            [readOnly]="readOnly"
            [milestone]="closingMilestone"
            [milestones]="[closingMilestone]"
            [approvalTypes]="approvalTypes"
          [project]="project"></app-milestone-sections>
          <!--        <app-disclosures-editor-->
          <!--          *ngFor="let milestone of milestones"-->
          <!--          [milestone]="milestone"-->
          <!--          (updateHTML)="recieveEditorHTML($event)"-->
          <!--          [project]="project"-->
<!--          [disclosure]="-->
<!--            disclosureForMilestone(milestone)-->
<!--          "></app-disclosures-editor>-->
        <app-committee-conditions
          title="LEGAL NOTES"
          [projectId]="project.id"
          [readOnly]="readOnly"
          [approvalType]="itemsService.getLegalApprovalType()"
          [isLegalNote]="true"
          [milestone]="closingMilestone"
          [milestoneId]="closingMilestone.id"
          [milestones]="[closingMilestone]"
          [headerColumns]="[
            'issue',
            'milestone',
            'actions'
          ]"></app-committee-conditions>
      </mat-card-content>
    </mat-card>
  </embedded-report>
</div>
}

